import { ReactNode } from 'react';

interface PublicLayoutProps {
  children: ReactNode;
  title?: string;
}

export default function PublicLayout({
  children,
  title: _title,
}: PublicLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-primary/5 via-background to-primary/10">
      <main className="flex-grow flex items-center justify-center">
        {children}
      </main>
    </div>
  );
}
